<template>
    <div class="login-page">
        <v-card class="login-card" elevation="8">
            <div class="logo-wrapper">
                <v-img src="@/assets/LOGOPARON 2023.svg" contain max-height="90" />
            </div>
            <div class="login-title">Administration panel</div>
            <v-alert v-if="$route.query.expired" type="info" text dense class="mb-4">
                Your session has expired. Please sign in again.
            </v-alert>
            <v-form ref="form" v-model="valid" @submit.prevent="submit">
                <v-text-field
                    v-model.trim="email"
                    :rules="[rules.required, rules.email]"
                    label="Email"
                    type="email"
                    autocomplete="username"
                    prepend-inner-icon="mdi-email-outline"
                    outlined
                    autofocus
                />
                <v-text-field
                    v-model="password"
                    :rules="[rules.required]"
                    :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="show ? 'text' : 'password'"
                    label="Password"
                    autocomplete="current-password"
                    prepend-inner-icon="mdi-lock-outline"
                    outlined
                    @click:append="show = !show"
                />
                <v-alert v-if="error" type="error" text dense>{{ error }}</v-alert>
                <v-btn
                    type="submit"
                    color="primary"
                    block
                    large
                    depressed
                    :loading="loading"
                    :disabled="!valid"
                >
                    Sign in
                </v-btn>
            </v-form>
        </v-card>
    </div>
</template>

<script>
    import userService from '@/services/user-service'
    import { errorMessage } from '@/utils/format'

    const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

    export default {
        name: 'LoginRoute',
        data() {
            return {
                show: false,
                valid: false,
                loading: false,
                email: '',
                password: '',
                error: null,
                rules: {
                    required: value => !!value || 'Required',
                    email: value => EMAIL_PATTERN.test(value) || 'Enter a valid email address'
                }
            }
        },
        methods: {
            submit() {
                if (!this.$refs.form.validate()) {
                    return
                }
                this.error = null
                this.loading = true
                userService.login({
                    username: this.email,
                    password: this.password
                }).then(resp => {
                    if (!['admin', 'dealer'].includes(resp.data.role)) {
                        this.error = 'This account cannot use the administration panel.'
                        return
                    }
                    return this.$store.dispatch('login', resp).then(() => {
                        const redirect = this.$route.query.redirect
                        this.$router.push(redirect && redirect.startsWith('/') ? redirect : '/')
                    })
                }).catch(error => {
                    const status = error.response && error.response.status
                    this.error = status === 401 ? 'Wrong email or password.' : errorMessage(error, 'Could not sign in')
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
.login-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: linear-gradient(135deg, #213050 0%, #2f4675 100%);
}

.login-card {
    width: 100%;
    max-width: 420px;
    padding: 32px 32px 28px;
    border-radius: 12px !important;
}

.logo-wrapper {
    margin: 0 auto 12px;
    max-width: 220px;
}

.login-title {
    text-align: center;
    font-size: 0.95rem;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 24px;
}
</style>
